import { useState } from 'react';
import {
  buildMainPlan,
  buildPlans,
  getOuterColClass,
  getColClass,
} from './RoamingProducts.utils';

const useRoamingProducts = (productsInfo, labels) => {
  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  const mainPlan = buildMainPlan(productsInfo?.travelPass, labels);
  const plans = buildPlans(productsInfo?.roamingNow || [], productsInfo?.travelTalk || [], labels);

  const outerColClass = getOuterColClass(mainPlan, plans.length);
  const colClass = getColClass(mainPlan, plans.length);
  const visibleCount = mainPlan ? 2 : 3;
  const visiblePlans = plans.length > visibleCount && !showAll ? plans.slice(0, visibleCount) : plans;

  return {
    mainPlan,
    visiblePlans,
    hasPlans: plans.length > 0,
    hasMorePlans: plans.length > visibleCount,
    outerColClass,
    colClass,
    showAll,
    toggleShowAll,
  };
};

export default useRoamingProducts;
